import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { CalendarDays, Clock, Users, TrendingUp, Loader2 } from "lucide-react";

export default function Dashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-brand-pink" size={28} /></div>;

  const stats = [
    { label: "Afspraken vandaag", value: data.today_count, icon: CalendarDays },
    { label: "Deze week", value: data.week_count, icon: TrendingUp },
    { label: "Totaal klanten", value: data.total_customers, icon: Users },
    { label: "Komende afspraken", value: data.upcoming.length, icon: Clock },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-4xl font-semibold text-brand-charcoal">Dashboard</h1>
      <p className="text-brand-muted mt-1 capitalize">{data.today_display}</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {stats.map((s) => (
          <div key={s.label} className="bg-white rounded-2xl border border-brand-border p-5">
            <s.icon className="text-brand-pink mb-3" size={22} />
            <p className="font-display text-3xl font-semibold text-brand-charcoal">{s.value}</p>
            <p className="text-sm text-brand-muted mt-1">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6 mt-8">
        <div className="bg-white rounded-2xl border border-brand-border p-6">
          <h2 className="font-display text-2xl font-medium text-brand-charcoal mb-4">Vandaag</h2>
          {data.today.length === 0 ? (
            <p className="text-brand-muted text-sm">Geen afspraken vandaag.</p>
          ) : (
            <div className="space-y-3">
              {data.today.map((a) => (
                <div key={a.id} className="flex items-center gap-4 p-3 rounded-xl bg-brand-blush">
                  <span className="font-display text-lg font-semibold text-brand-charcoal w-14">{a.start_time}</span>
                  <div className="min-w-0">
                    <p className="font-medium text-brand-charcoal truncate">{a.first_name} {a.last_name}</p>
                    <p className="text-sm text-brand-muted truncate">{a.service_category} · {a.service_name}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="bg-white rounded-2xl border border-brand-border p-6">
          <h2 className="font-display text-2xl font-medium text-brand-charcoal mb-4">Komende afspraken</h2>
          {data.upcoming.length === 0 ? (
            <p className="text-brand-muted text-sm">Geen komende afspraken.</p>
          ) : (
            <div className="space-y-3">
              {data.upcoming.slice(0, 6).map((a) => (
                <div key={a.id} className="flex items-center justify-between gap-3 p-3 rounded-xl border border-brand-border">
                  <div className="min-w-0">
                    <p className="font-medium text-brand-charcoal truncate">{a.first_name} {a.last_name}</p>
                    <p className="text-sm text-brand-muted truncate">{a.service_name}</p>
                  </div>
                  <div className="text-right shrink-0">
                    <p className="text-sm font-medium text-brand-charcoal capitalize">{a.date_display.split(" ").slice(0, 3).join(" ")}</p>
                    <p className="text-sm text-brand-muted">{a.start_time}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
